const GA_MEASUREMENT_ID = "UA-145126284-3";
window.dataLayer = window.dataLayer || [];
window[`ga-disable-${GA_MEASUREMENT_ID}`] = window.location.hostname !== "app.witful.com";
export function gtag() {
  dataLayer.push(arguments);
}
gtag("js", new Date());
gtag("config", GA_MEASUREMENT_ID, {send_page_view: false});
